export default () => {
  self.onmessage = () => {
    setInterval(() => {
      postMessage(true);
    }, 1000);
  };
};
